import type { BubbleAxisAnchor, BubblePosition } from "../types";

const horizontalWord = (anchor: BubbleAxisAnchor): "left" | "right" | "center" => {
  if (anchor.type === "start") {
    return "left";
  }
  if (anchor.type === "end") {
    return "right";
  }
  return "center";
};

const verticalWord = (anchor: BubbleAxisAnchor): "top" | "bottom" | "center" => {
  if (anchor.type === "start") {
    return "top";
  }
  if (anchor.type === "end") {
    return "bottom";
  }
  return "center";
};

export const getMorphOrigin = (position: BubblePosition): string =>
  `${verticalWord(position.vertical)} ${horizontalWord(position.horizontal)}`;
